import AssignTeam from './AssignTeam';

export default AssignTeam;
